var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
export class GlobalAdminViewModel {
    constructor(container) {
        this.globalAdminUIManager = container.globalAdminUIManager;
    }
    get currentTab() {
        return this.globalAdminUIManager.currentTab;
    }
    setCurrentTab(tab) {
        this.globalAdminUIManager.setCurrentTab(tab);
    }
    get tabsToShow() {
        return this.globalAdminUIManager.tabsToShow;
    }
    get pageTitle() {
        return "Global Admin";
    }
}
__decorate([
    computed
], GlobalAdminViewModel.prototype, "currentTab", null);
__decorate([
    computed
], GlobalAdminViewModel.prototype, "tabsToShow", null);
__decorate([
    computed
], GlobalAdminViewModel.prototype, "pageTitle", null);
